$(document).ready(function() {

	// scroll links
	$('.scrollDown').on('click', function(e) {
    e.preventDefault();
    var thisRef = $(this).attr('href');
    $('body, html').animate({
      scrollTop: $( thisRef ).offset().top - 200
    }, 800);
	});

	// Sticky nav changes once scrolled
	var header = $(".header");

  $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 50) {
          header.addClass("scrolled");
      } else {
          header.removeClass("scrolled");
      }
  });

});

$('#contactForm').submit(function(ev) {
    // Prevent the form from actually submitting
    ev.preventDefault();
    $('#contactSubmit').html("One Moment...");

    // Send it to the server
    $.post({
        url: '/',
        dataType: 'json',
        data: $(this).serialize(),
        success: function(response) {
            if (response.success) {
                $('#thanks').fadeIn();
                $('#contactSubmit').html("Send");
                $("#contactForm #from-name").val('');
                $("#contactForm #from-email").val('');
                $("#contactForm #phone").val('');
                $("#contactForm #message").val('');
            } else {
                // response.error will be an object containing any validation errors that occurred, indexed by field name
                // e.g. response.error.fromName => ['From Name is required']
                alert('An error occurred. Please check your form fields and try again.');
                $('#contactSubmit').html("Send");
            }
        }
    });
});


// Stop videos in modal if playing when you click close
$('.videoModal').on('hide.bs.modal', function(e) {
    var $if = $(e.delegateTarget).find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);
});

// Carousel
$('#carousel').on('slide.bs.carousel', function (e) {
    /*
        CC 2.0 License Iatek LLC 2018 - Attribution required
    */
    var $e = $(e.relatedTarget);
    var idx = $e.index();
    var itemsPerSlide = 4;
    var totalItems = $('.carousel-item').length;
 
    if (idx >= totalItems-(itemsPerSlide-1)) {
        var it = itemsPerSlide - (totalItems - idx);
        for (var i=0; i<it; i++) {
            // append slides to end
            if (e.direction=="left") {
                $('.carousel-item').eq(i).appendTo('.carousel-inner');
            }
            else {
                $('.carousel-item').eq(0).appendTo('.carousel-inner');
            }
        }
    }
});